module.exports = __webpack_public_path__ + "img/logo-1-black.981d3a6e.png";